<template>
  <div v-if="enabled" class="grab-hydraulic-fluid-pressure-component">
    <apexchart
      type="line"
      height="400"
      :options="chartOptions"
      :series="series"
      v-if="measurementsData"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts"
import MeasurementsFactory from "@/utils/measurementsfactory"
import pressureUtils from "@/utils/pressure"

export default {
  props: ["machine", "dates", "measurementsData"],
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      enabled: false
    }
  },
  computed: {
    pressureSymbol() {
      return pressureUtils.getSymbol(this.units)
    },
    units() {
      return this.$store.getters.userDetails?.preferences?.units || "metric"
    },
    chartOptions() {
      return {
        chart: {
          fontFamily: "Roboto, sans-serif",
          height: 350,
          type: "line",
          animations: {
            enabled: false
          },
          toolbar: {
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: false,
              zoomout: true,
              pan: false,
              reset: "<i class='v-icon mdi mdi-overscan'></i>"
            }
          }
        },
        colors: ["#F86624"], // palette6, column 2 from https://apexcharts.com/docs/options/theme/
        noData: {
          text: this.$t("$vuetify.noDataText")
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "stepline",
          width: 4
        },
        title: {
          text: this.$t("machines.measurements.hydraulicFluidPressure"),
          align: "left"
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        markers: {
          size: 0
        },
        xaxis: {
          type: "datetime",
          // Add 24h prior to and 24h after the selected time range,
          // so that all data points are  properly displayed.
          min: new Date(this.dates[0]).getTime() - 24 * 3600 * 1000,
          max: new Date(this.dates[1]).getTime() + 24 * 3600 * 1000
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy HH:mm:ss"
          }
        },
        yaxis: {
          title: {
            text: `${this.$t("chart.legend.pressure")} (${this.pressureSymbol})`
          },
          min: 0,
          max: max => {
            return max + 10
          }
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5
        }
      }
    },
    series() {
      let pressureSeries = MeasurementsFactory.makeAreaSeries(
        this.measurementsData,
        [
          {
            name: this.$t("machines.measurements.hydraulicFluid"),
            parameterId: "M4",
            data: []
          }
        ],
        rawValue => {
          return Number(
            pressureUtils.convertFromBar(rawValue, this.units)
          ).toFixed(0)
        }
      )
      return pressureSeries
    }
  },
  mounted() {
    this.enabled = true
  },
  watch: {
    dates() {
      // Hack to fix issue with xaxis min max not updating on date change
      this.enabled = false
      setTimeout(() => {
        this.enabled = true
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped></style>
